import { createLink, type LinkComponent } from "@tanstack/react-router";
import { forwardRef, type AnchorHTMLAttributes, type ReactNode } from "react";
import { buttonClasses } from "./button";

type Variant = Parameters<typeof buttonClasses>[0];
type Size = Parameters<typeof buttonClasses>[1];

interface ButtonAnchorProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  variant?: Variant;
  size?: Size;
  icon?: ReactNode;
}

const ButtonAnchor = forwardRef<HTMLAnchorElement, ButtonAnchorProps>(function ButtonAnchor({ variant, size, icon, className, children, ...rest }, ref) {
  return (
    <a ref={ref} {...rest} className={buttonClasses(variant, size, className)}>
      {icon}
      {children}
    </a>
  );
});

const Created = createLink(ButtonAnchor);

/**
 * A router `<Link>` that looks like a `<Button>`: one interactive element with proper link semantics
 * (never a button nested in a link). Built with `createLink`, so `to` / `params` / `search` are typed
 * against the route tree exactly like `<Link>`.
 */
export const ButtonLink: LinkComponent<typeof ButtonAnchor> = (props) => <Created preload="intent" {...props} />;
